import { g as r } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as f, createElementVNode as o, createStaticVNode as e } from "vue";
import { _ as p } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconPlayStoreBadge",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(l).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], m = ["id"], Z = ["id"], v = ["id"], g = ["id"], y = { "data-name": "Layer 2" }, V = ["fill"], c = ["fill"], I = ["fill"], S = ["fill"];
function q(a, t, i, A, b, s) {
  return n(), d("svg", {
    "aria-label": i.ariaLabel,
    class: f([s.iconSizeClass, "d-icon d-icon--play-store-badge"]),
    "data-qa": s.dataQA,
    "aria-hidden": s.ariaHidden,
    role: "img",
    "data-name": "Play Store Badge",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 40"
  }, [
    o("defs", null, [
      o("linearGradient", {
        id: `${a.uniqueID}a`,
        x1: "21.8",
        y1: "366.71",
        x2: "5.02",
        y2: "383.49",
        gradientTransform: "translate(0 -358)",
        gradientUnits: "userSpaceOnUse"
      }, [...t[0] || (t[0] = [
        e('<stop offset="0" stop-color="#00a0ff"></stop><stop offset=".01" stop-color="#00a1ff"></stop><stop offset=".26" stop-color="#00beff"></stop><stop offset=".51" stop-color="#00d2ff"></stop><stop offset=".76" stop-color="#00dfff"></stop><stop offset="1" stop-color="#00e3ff"></stop>', 6)
      ])], 8, m),
      o("linearGradient", {
        id: `${a.uniqueID}b`,
        x1: "33.83",
        y1: "378",
        x2: "9.64",
        y2: "378",
        gradientTransform: "translate(0 -358)",
        gradientUnits: "userSpaceOnUse"
      }, [...t[1] || (t[1] = [
        o("stop", {
          offset: "0",
          "stop-color": "#ffe000"
        }, null, -1),
        o("stop", {
          offset: ".41",
          "stop-color": "#ffbd00"
        }, null, -1),
        o("stop", {
          offset: ".78",
          "stop-color": "orange"
        }, null, -1),
        o("stop", {
          offset: "1",
          "stop-color": "#ff9c00"
        }, null, -1)
      ])], 8, Z),
      o("linearGradient", {
        id: `${a.uniqueID}c`,
        x1: "24.83",
        y1: "380.3",
        x2: "2.07",
        y2: "403.05",
        gradientTransform: "translate(0 -358)",
        gradientUnits: "userSpaceOnUse"
      }, [...t[2] || (t[2] = [
        o("stop", {
          offset: "0",
          "stop-color": "#ff3a44"
        }, null, -1),
        o("stop", {
          offset: "1",
          "stop-color": "#c31162"
        }, null, -1)
      ])], 8, v),
      o("linearGradient", {
        id: `${a.uniqueID}d`,
        x1: "7.3",
        y1: "358.18",
        x2: "17.46",
        y2: "368.34",
        gradientTransform: "translate(0 -358)",
        gradientUnits: "userSpaceOnUse"
      }, [...t[3] || (t[3] = [
        e('<stop offset="0" stop-color="#32a071"></stop><stop offset=".07" stop-color="#2da771"></stop><stop offset=".48" stop-color="#15cf74"></stop><stop offset=".8" stop-color="#06e775"></stop><stop offset="1" stop-color="#00f076"></stop>', 5)
      ])], 8, g)
    ]),
    o("g", y, [
      t[4] || (t[4] = o("rect", {
        width: "135",
        height: "40",
        rx: "5",
        ry: "5"
      }, null, -1)),
      t[5] || (t[5] = o("path", {
        fill: "#A6A6A6",
        d: "M130 .8a4.2 4.2 0 0 1 4.2 4.2v30a4.2 4.2 0 0 1-4.2 4.2H5A4.2 4.2 0 0 1 .8 35V5A4.2 4.2 0 0 1 5 .8h125m0-.8H5a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5Z"
      }, null, -1)),
      t[6] || (t[6] = o("path", {
        fill: "#FFF",
        stroke: "#FFF",
        "stroke-miterlimit": "10",
        "stroke-width": ".2",
        d: "M47.42 10.24a2.71 2.71 0 0 1-.75 2 2.91 2.91 0 0 1-2.2.89 3.15 3.15 0 0 1-2.21-5.37 3 3 0 0 1 2.21-.9 3.1 3.1 0 0 1 1.23.25 2.47 2.47 0 0 1 .94.67l-.53.53a2 2 0 0 0-1.64-.71 2.32 2.32 0 0 0-2.33 2.31s0 .06 0 .09a2.36 2.36 0 0 0 4 1.73 1.89 1.89 0 0 0 .5-1.22h-2.17v-.72h2.91a2.54 2.54 0 0 1 .04.45ZM52 7.74h-2.7v1.9h2.46v.72H49.3v1.9H52V13h-3.5V7H52ZM55.28 13h-.77V7.74h-1.68V7H57v.74h-1.72Zm4.66 0V7h.77v6Zm4.19 0h-.77V7.74h-1.68V7h4.12v.74h-1.67Zm9.48-.78a3.12 3.12 0 0 1-4.4 0 3.24 3.24 0 0 1 0-4.45 3.1 3.1 0 0 1 4.38 0 3.23 3.23 0 0 1 .02 4.45Zm-3.83-.5a2.31 2.31 0 0 0 3.26 0 2.56 2.56 0 0 0 0-3.44 2.31 2.31 0 0 0-3.26 0 2.56 2.56 0 0 0 0 3.44Zm5.8 1.28V7h.94l2.92 4.67V7h.77v6h-.8l-3.05-4.89V13Z"
      }, null, -1)),
      t[7] || (t[7] = o("path", {
        fill: "#FFF",
        d: "M68.14 21.75A4.25 4.25 0 1 0 72.41 26a4.19 4.19 0 0 0-4.13-4.25Zm0 6.83a2.58 2.58 0 1 1 2.39-2.75V26a2.46 2.46 0 0 1-2.34 2.58Zm-9.31-6.83A4.25 4.25 0 1 0 63.09 26 4.19 4.19 0 0 0 59 21.75h-.13Zm0 6.83a2.58 2.58 0 1 1 2.38-2.76V26a2.46 2.46 0 0 1-2.34 2.58h-.05Zm-11.09-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.42 4.42 0 0 1-3.33 1.32 4.8 4.8 0 0 1 0-9.6A4.6 4.6 0 0 1 51 20.14l1.27-1.27A6.29 6.29 0 0 0 47.74 17a6.61 6.61 0 1 0-.51 13.21h.51a5.84 5.84 0 0 0 6.17-6.07 5.87 5.87 0 0 0-.1-1.13Zm45.31 1.4a3.92 3.92 0 0 0-7.65 1.28V26a4.16 4.16 0 0 0 4.07 4.25h.15a4.23 4.23 0 0 0 3.54-1.88l-1.45-1a2.43 2.43 0 0 1-2.09 1.18 2.16 2.16 0 0 1-2.06-1.29l5.69-2.35Zm-5.8 1.42a2.33 2.33 0 0 1 2.17-2.48 1.65 1.65 0 0 1 1.58.9ZM82.63 30h1.87V17.5h-1.87Zm-3.06-7.3h-.07a3 3 0 0 0-2.24-1 4.26 4.26 0 0 0 0 8.51 2.9 2.9 0 0 0 2.24-1h.06v.61c0 1.63-.87 2.5-2.27 2.5a2.35 2.35 0 0 1-2.14-1.51l-1.63.68A4.05 4.05 0 0 0 77.29 34c2.19 0 4-1.29 4-4.43V22h-1.72Zm-2.14 5.88a2.59 2.59 0 0 1 0-5.16 2.4 2.4 0 0 1 2.27 2.52V26a2.38 2.38 0 0 1-2.17 2.57h-.1Zm24.38-11.08h-4.47V30h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76Zm0 6H99.2v-4.26h2.65a2.14 2.14 0 0 1 0 4.29Zm11.53-1.8a3.5 3.5 0 0 0-3.34 1.91l1.66.69a1.77 1.77 0 0 1 1.7-.92 1.8 1.8 0 0 1 2 1.58v.16a4.13 4.13 0 0 0-1.95-.48c-1.79 0-3.6 1-3.6 2.81a2.89 2.89 0 0 0 3 2.75h.08a2.63 2.63 0 0 0 2.4-1.2h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46Zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.33 2-1.33a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1-2.19 2ZM123.74 22l-2.14 5.42h-.06L119.32 22h-2l3.33 7.58-1.9 4.21h1.95L125.82 22Zm-16.81 8h1.87V17.5h-1.87Z"
      }, null, -1)),
      o("path", {
        fill: `url(#${a.uniqueID}a)`,
        d: "M10.44 7.54a2 2 0 0 0-.44 1.4v22.12a2 2 0 0 0 .46 1.4l.07.07L22.9 20.15v-.29L10.51 7.47Z"
      }, null, 8, V),
      o("path", {
        fill: `url(#${a.uniqueID}b)`,
        d: "m27 24.28-4.1-4.13v-.29l4.1-4.14h.09L32 18.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78Z"
      }, null, 8, c),
      o("path", {
        fill: `url(#${a.uniqueID}c)`,
        d: "M27.12 24.22 22.9 20 10.44 32.46a1.63 1.63 0 0 0 2.08.06l14.61-8.3"
      }, null, 8, I),
      o("path", {
        fill: `url(#${a.uniqueID}d)`,
        d: "m27.12 15.78-14.61-8.3a1.63 1.63 0 0 0-2.08.06L22.9 20Z"
      }, null, 8, S),
      t[8] || (t[8] = o("path", {
        opacity: ".2",
        d: "m27 24.13-14.49 8.25a1.67 1.67 0 0 1-2 0l-.07.07.07.07a1.66 1.66 0 0 0 2 0l14.61-8.3Z"
      }, null, -1)),
      t[9] || (t[9] = o("path", {
        style: { isolation: "isolate" },
        d: "M10.44 32.32a2 2 0 0 1-.46-1.4v.15a2 2 0 0 0 .46 1.4l.07-.07Z"
      }, null, -1)),
      t[10] || (t[10] = o("path", {
        opacity: ".12",
        style: { isolation: "isolate" },
        d: "m32 21.3-5 2.83.09.09L32 21.44A1.75 1.75 0 0 0 33 20a1.86 1.86 0 0 1-1 1.3Z"
      }, null, -1)),
      t[11] || (t[11] = o("path", {
        opacity: ".25",
        style: { isolation: "isolate" },
        d: "M12.51 7.62 32 18.7a1.86 1.86 0 0 1 1 1.3 1.75 1.75 0 0 0-1-1.44L12.51 7.48C11.11 6.69 10 7.35 10 8.95v.15c0-1.61 1.12-2.27 2.51-1.48Z"
      }, null, -1))
    ])
  ], 10, h);
}
const $ = /* @__PURE__ */ p(u, [["render", q]]);
export {
  $ as default
};
//# sourceMappingURL=play-store-badge.js.map
